import { useCallback } from "react";

// Used by useQueryParamsManager only
export const useMockableNavigate = () => {
  return useCallback((params: URLSearchParams, location: Location) => {
    const url = new URL(location.href);
    url.search = params.toString();
    if (url.toString() !== location.href) {
      window.history.pushState({}, "", url.toString());
    }
  }, []);
};
